import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISimpleData } from '../../../../../shared/models/simpleData.model';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../services/toast.service';

@Component({
  selector: 'app-add-edit-flight-service-types-dialog',
  templateUrl: './add-edit-flight-service-types-dialog.component.html',
  styleUrls: ['./add-edit-flight-service-types-dialog.component.scss']
})
export class AddEditFlightServiceTypesDialogComponent implements OnInit {

  form?: FormGroup;
  isBusy = false;
  @Input() flightServiceType?: ISimpleData;
  @Input() title?: string;
  constructor(private generalSettingsService: GeneralSettingsService, private activeModal: NgbActiveModal, private toastService: ToastService) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl(this.flightServiceType?.code || '', Validators.required),
      description: new FormControl(this.flightServiceType?.description || '', Validators.required)
    });
  }

  closeModal(reason?: any) {
    this.activeModal.dismiss(reason);
  }

  onSaveClick() {
    const data = { ...this.form.value, id: this.flightServiceType?.id };
    this.isBusy = true;
    this.generalSettingsService.saveFlightServiceType(data).subscribe((result) => {
      if(result?.id) {
        this.toastService.showSuccess("Flight Service Type has been saved");
        this.closeModal(true);
      }
      this.isBusy = false;
    });
  }

}
